<template>
    <!-- id="edit-file" modal-class="modal--edit" title="Editing Tutorial Santa Duck.stl" -->
    <div>
        <label>
            <span>{{$t('files.base.title')}}</span>
            <input type="text" class="inp" v-model="data.filename">
        </label>

        <!--<label> <span>{{$t('files.modal.fileEdit.defaultSlicingProfiles')}}</span>-->

            <!--<vue-multiselect v-model="value" label="name" :options="options"   :multiple="true"  placeholder="Pick a value"></vue-multiselect>-->

            <!--&lt;!&ndash;<input type="text" class="inp" value="TODO: Multiselect">&ndash;&gt;-->
        <!--</label> <label><span>{{$t('files.modal.fileEdit.publicSharing')}}</span>-->
        <!--<b-checkbox class="check" >{{$t('files.modal.fileEdit.allowToDisplayInSearch')}}</b-checkbox>-->
    <!--</label>-->
        <!--<div v-if="shareObj">-->
            <!--<label> <span>Description</span> <input type="text" class="inp" value="Editing Tutorial Santa Duck">-->
            <!--</label> <label> <span>Related tags</span> <input type="text" class="inp" value="TODO: Multiselect">-->
        <!--</label>-->
        <!--</div>-->
        <!--<template v-slot:modal-footer="{ cancel, ok }">-->
            <!--<div class="modal__footer&#45;&#45;left">-->
                <!--<b-button variant="-gray" @click="cancel()">-->
                    <!--Cancel-->
                <!--</b-button>-->
            <!--</div>-->
            <!--<div class="modal__footer&#45;&#45;right">-->
                <!--<b-button variant="-primary" @click="ok()">-->
                    <!--Save-->
                <!--</b-button>-->
            <!--</div>-->
        <!--</template>-->
    </div>
</template>

<script>
 // import Multiselect from 'vue-multiselect'
    import { mapActions } from 'vuex'
 // import VueMultiselect from "vue-multiselect/src/Multiselect";
  export default {
    name: "FileEdit",
   // components: {VueMultiselect},
    props: ['data'],
    data () {
      return{
        value: '',
        options: []

      }
    },
    methods: {
      ...mapActions(['updateFile']),
      ok (){
        this.updateFile(this.data)
        this.$emit('hideModel')
      }
    },
    created() {
      console.log(this.data);
      window.axios.post('/ajax/get_slicing_profiles_for_magicsuggest').then((response) =>  {
        this.options = response.data
        console.log(this.options)
      })
    }
  }
</script>

<style scoped>

</style>
